export class IndicationModel {
    indicationID: string
    indications: string
    MaxDosage: number
    MinDosage: number
    constructor(
        indicationID: string,
        indications: string,
        maxDosage: number = 0,
        minDosage: number = 0
    )
    {
        this.indicationID = indicationID;
        this.indications = indications;
        this.MaxDosage = maxDosage;
        this.MinDosage = minDosage;
    }
}

